__turbopack_context__.v({
  "gallery": "ReviewsMediaSlider-module-scss-module__cUOiRq__gallery",
  "mediaList": "ReviewsMediaSlider-module-scss-module__cUOiRq__mediaList",
  "mediaMore": "ReviewsMediaSlider-module-scss-module__cUOiRq__mediaMore",
  "mediaOpenButton": "ReviewsMediaSlider-module-scss-module__cUOiRq__mediaOpenButton",
  "mediaPreview": "ReviewsMediaSlider-module-scss-module__cUOiRq__mediaPreview",
  "mediaSkeletonItem": "ReviewsMediaSlider-module-scss-module__cUOiRq__mediaSkeletonItem",
  "mediaSkeletonList": "ReviewsMediaSlider-module-scss-module__cUOiRq__mediaSkeletonList",
});
